var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-container',{attrs:{"fit-content":"","vertical-center":""}},[_c('base-text',{staticClass:"body-caption",attrs:{"value":"勤怠状況："}}),_c('invoice-partner-roster-status-label',{attrs:{"status":_vm.partnerRosterStatusLabelValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }